/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { FieldArray } from "formik";

// TC UX
import InfoArea from "components/InfoArea/InfoArea.jsx";

// @material-ui/icons
import { HowToReg, TableChart, RecordVoiceOver } from "@material-ui/icons";

// import { Modal } from "components/Modal/Modal";
// import { isProd } from "assets/jss/views/PhoenixCommons";
import { checkboxListForArray } from "components/Form/FormField";

import { sYourJob, sYourAreas, sHowFound } from "assets/jss/views/ResStrings";

const jobTypeList = [
  { id: "js", name: "Student" },
  { id: "jn", name: "Nurse" },
  { id: "jt", name: "Teacher" },
  { id: "jo", name: "Other" },
];

const howFoundList = [
  { id: "hf0", name: "Our YouTube channel" },
  { id: "hf1", name: "Friend/Classmate" },
  { id: "hf2", name: "Social Media" },
  { id: "hf3", name: "Teacher" },
  { id: "hf4", name: "Advertisement" },
  { id: "hf5", name: "Search engine (Google, Yahoo...)" },
  { id: "hf6", name: "Other" },
];
const areaTypeList = [
  { id: "cat0", name: "Pathophysiology" },
  { id: "cat1", name: "Pharmacology" },
  { id: "cat2", name: "Fundamentals" },
  { id: "cat3", name: "Nursing Skills" },
  { id: "cat4", name: "Medical-Surgical Nursing" },
  { id: "cat5", name: "Pediatric Nursing" },
  { id: "cat6", name: "Maternal-Newborn Nursing Care" },
  { id: "cat7", name: "Gerontological" },
  { id: "cat8", name: "Public Health" },
  { id: "cat9", name: "Clinical Support" },
  { id: "cat10", name: "Other" },
];

export const renderJobSection = (props: any, classes: any) => {
  const { values, errors, touched } = props;

  return (
    <>
      <InfoArea
        className={classes.infoArea}
        title={sYourJob}
        description=""
        icon={HowToReg}
        iconColor="primary"
      />
      <FieldArray
        name="jobs"
        render={checkboxListForArray({
          dataList: jobTypeList,
          valueSet: values.jobs,
          valueName: "jobs",
          errors,
          touched,
        })}
      />
    </>
  );
};

export const renderAreaSection = (props: any, classes: any) => {
  const { values, errors, touched } = props;

  return (
    <>
      <InfoArea
        className={classes.infoArea}
        title={sYourAreas}
        description=""
        icon={TableChart}
        iconColor="clipbrd"
      />
      <FieldArray
        name="areas"
        render={checkboxListForArray({
          dataList: areaTypeList,
          valueSet: values.areas,
          valueName: "areas",
          errors,
          touched,
        })}
      />
    </>
  );
};

export const renderHowFoundSection = (props: any, classes: any) => {
  const { values, errors, touched } = props;

  return (
    <>
      <InfoArea
        className={classes.infoArea}
        title={sHowFound}
        description=""
        icon={RecordVoiceOver}
        iconColor="note"
      />
      <FieldArray
        name="howf"
        render={checkboxListForArray({
          dataList: howFoundList,
          valueSet: values.howf,
          valueName: "howf",
          errors,
          touched,
        })}
      />
    </>
  );
};

// function verifyAccessCode(code: string | null) {
//   if (code === null) return false;

//   const access = parseInt(code, 10);
//   const p1: number = 1069;
//   const p2: number = 521;
//   const p3: number = 929;
//   var k: number = access - p3;
//   for (var i = 0; i < 20; i++) {
//     if (k % i === 0 && (k / i - p2) % p1 === 0) return true;
//   }
//   return false;
// }

// const handleEvaluationCode = (id: number, input: string) => {
//   sessionStorage.accessKey = input;
// };

type AccessCodeResult = {
  passed: boolean;
  alertModal: React.ReactElement;
};

export function checkAccessCode(onExit: () => void): AccessCodeResult {
  // if (!isProd) {
  return { passed: true, alertModal: <></> };
  // }

  // var code = "";
  // const storageExist = typeof Storage !== "undefined";

  // if (storageExist && sessionStorage.accessKey) {
  //   code = sessionStorage.accessKey;
  // } else {
  //   return {
  //     passed: false,
  //     alertModal: (
  //       <Modal
  //         title={sPreview}
  //         label={"Code"}
  //         password
  //         nobackdrop
  //         onButtons={handleEvaluationCode}
  //         onExit={onExit}>
  //         {sPreviewMsg}
  //       </Modal>
  //     ),
  //   };
  // }

  // if (verifyAccessCode(code) === false) {
  //   sessionStorage.removeItem("accessKey");
  //   return {
  //     passed: false,
  //     alertModal: (
  //       <Modal title={"Invalid Code"} onExit={onExit} color="warning">
  //         The promotion code is invalid.
  //       </Modal>
  //     ),
  //   };
  // } else {
  //   if (storageExist && !sessionStorage.accessKey) {
  //     sessionStorage.accessKey = code;
  //   }
  // }

  // return { passed: true, alertModal: <></> };
}
